(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('transactionHistoryCtrl', ['$scope', '$sce', '$filter', '$http', 'httpService', 'prepaidUserInfoService', 'uteEndpoint', '$rootScope', '$stateParams', '$state', 'commonService', 'prepaidAirtimeBalanceService', 'prepaidPlanInfoService', 'prepaidAutoRefillInfoService', 'transactionHistoryService', 'uteLocale', function ($scope, $sce, $filter, $http, httpService, prepaidUserInfoService, uteEndpoint, $rootScope, $stateParams, $state, commonService, prepaidAirtimeBalanceService, prepaidPlanInfoService, prepaidAutoRefillInfoService, transactionHistoryService, uteLocale) {

      $scope.go = function (state) {
        $state.go(state);
      };

      $scope.moveAround = false;
      $scope.mobileView = false;

      $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        // we want to check the initial request to redirect and reject it; then we can revert the flag
        if ($scope.moveAround === false) {
          event.preventDefault();
          // revert flag
          $scope.moveAround = true;
        }

      });

      var width = window.innerWidth;
      if (width < 500) {
        $scope.mobileView = true;
      } else {
        $scope.mobileView = false;
      }

      $scope.tabData = [{
        heading: 'wireless.label.calls',
        route: 'myAccount.viewTransactionHistory.call'
      }, {
        heading: 'wireless.label.fidoTransactions',
        route: 'myAccount.viewTransactionHistory.fidoTransaction'
      }, {
        heading: 'wireless.label.thirdPartyTransactions',
        route: 'myAccount.viewTransactionHistory.thirdPartyTransaction'
      }];

      $scope.ctn = prepaidUserInfoService.getCTN();
      $scope.ban = prepaidUserInfoService.getBAN();
      $scope.language = uteLocale.language;
      $scope.showLoader = true;
      $scope.showTabs = false;

      if($rootScope.userInfo){
        if($scope.ban != null && $scope.ban != '' && $scope.ban != $rootScope.userInfo.selectedAccountNumber){
          $rootScope.userInfo.selectedAccountNumber = $scope.ban;
        }
        if($scope.ctn != null && $scope.ctn != '' && $scope.ctn != $rootScope.userInfo.selectedSubscriberNo){
          $rootScope.userInfo.selectedSubscriberNo = $scope.ctn;
        }
      }

      var promise = httpService.send(
        'v1/wireless/prepaid/dashboard/plan', // TODO : Need to change
        {
          accountNumber: $scope.ban,
          ctn: $scope.ctn,
          language: $scope.language
        });

      promise.then(
        function (result) {
          if (result.data.error || result.data.status == 'Failed') {
            $scope.planAndAddOnInfoError = true;
          } else {
            $scope.airTimeBalance = result.data.airtimeBalance;
            /*Changes are cherry picked as part previous release*/
            $scope.expiryDate = result.data.expiryDate;
            //$scope.expiryDate = new Date($scope.expDate);
          }
        },
        function (reason) {
          $scope.planAndAddOnInfoError = true;
        }
      );

      var promise = httpService.send(
        'v1/wireless/prepaid/transaction/history', // TODO : Need to change
        {
          accountNumber: prepaidUserInfoService.getBAN(),
          ctn: prepaidUserInfoService.getCTN()

        });

      promise.then(
        function (result) {
          if (result.data.error || result.data.status == 'Failed') {
            $scope.transactionHistoryInfoError = true;
            $scope.showLoader = false;
          } else {
            $scope.showLoader = false;
            $scope.showTabs = true;
            transactionHistoryService.setResponse(result.data);

          }
        },
        function (reason) {
          $scope.transactionHistoryInfoError = true;
          $scope.showLoader = false;
        }
      );

      $scope.fetchWLPPInfoOnDirectLoad = function () {
        $scope.getPlanAndAddOnInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
      };

      $scope.getPlanAndAddOnInfo = function (accountNumber, subscriberNumber, language) {
        var promise = httpService.send(
          'v1/wireless/prepaid/dashboard/plan', // TODO : Need to change
          {
            accountNumber: accountNumber,
            ctn: subscriberNumber,
            language: language
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.planAndAddOnInfoError = true;
            } else {
              //alert('Got PlanAndAddOnInfo Successfully');
              $scope.planAndAddOnInfo = result.data;
              console.log('$scope.planAndAddOnInfo :: ' + $scope.planAndAddOnInfo);
              prepaidAirtimeBalanceService.setAirTimeBalance($scope.planAndAddOnInfo.airtimeBalance);
              prepaidAirtimeBalanceService.setExpiryDate($scope.planAndAddOnInfo.expiryDate);
              prepaidPlanInfoService.setAirTimePlanFee($scope.planAndAddOnInfo.pricePlan);
              $scope.pricePlanInfo = null;
              if (result.data.planDetailsInfo != null) {
                if ($scope.language === 'en' || $scope.language === 'EN') {
                  $scope.pricePlanInfo = result.data.planDetailsInfo.en;
                } else {
                  $scope.pricePlanInfo = result.data.planDetailsInfo.fr;
                }
                if (result.data.planDetailsInfo.productId != null && result.data.planDetailsInfo.productId != '') {
                  prepaidPlanInfoService.setAirTimePlanSoc(result.data.planDetailsInfo.productId);
                } else {
                  prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                }
                if ($scope.pricePlanInfo != null && $scope.pricePlanInfo.planComparison != null && $scope.pricePlanInfo.planComparison.planTitle != null && $scope.pricePlanInfo.planComparison.planTitle != '') {
                  prepaidPlanInfoService.setAirTimePlanTitle($scope.pricePlanInfo.planComparison.planTitle);
                } else {
                  if ($scope.language === 'en' || $scope.language === 'EN') {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                  } else {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                  }
                }
              } else {
                if ($scope.language === 'en' || $scope.language === 'EN') {
                  prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                } else {
                  prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                }
                prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
              }
              $scope.planDesc = prepaidPlanInfoService.getAirTimePlanTitle();
              prepaidPlanInfoService.setAirTimePlanFeatures($scope.pricePlanInfo);
              $scope.getAutoRefillSubscriptionInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
            }
          },
          function (reason) {
            $scope.planAndAddOnInfoError = true;
          }
        );
      };

      $scope.getAutoRefillSubscriptionInfo = function (accountNumber, subscriberNumber, language) {
        var promise = httpService.send(
          'v1/refill/autorefill/scheduled/details', // TODO : Need to change
          {
            accountNumber: accountNumber,
            ctn: subscriberNumber,
            language: language
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.error != '') {
              $scope.autoRefillSubscriptionInfoError = true;
              console.log('AutoRefillSubscriptionInfo Error');
            } else {
              console.log('Got AutoRefillSubscriptionInfo Successfully');
              $scope.autoRefillSubscriptionInfo = result.data;
              console.log('$scope.autoRefillSubscriptionInfo :: ' + $scope.autoRefillSubscriptionInfo);
              prepaidAutoRefillInfoService.setAutoPayPlanInfo($scope.autoRefillSubscriptionInfo.autoPayPlan);
              prepaidAutoRefillInfoService.setAutoRefillBalanceInfo($scope.autoRefillSubscriptionInfo.autoRefillBalance);
              var $translate = $filter('translate');
              var $currency = $filter('currency');
              if (prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag) {
                var $date = $filter('date');
                var scheduledRefillDate = new Date($scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate);
                $scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate = scheduledRefillDate;
                prepaidAutoRefillInfoService.setAutoPayPlanSubContent('<p class="fido-tick-icon">' + $translate('global.label.nextPaymentOf') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoPayPlanInfo().rechargeAmount) + '</p><p>' + $translate('global.label.autoPayPlanBridge') + ' ' + $date(scheduledRefillDate, 'MMMM dd, yyyy') + '</p>');
                prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-2');
                if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                  prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('<p class="fido-tick-icon-secondary">' + $translate('global.label.add') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) + ' ' + $translate('global.label.autoRefillBalanceBridge') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) + '</p>');
                  prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9');
                } else {
                  prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                  prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                }
              } else {
                prepaidAutoRefillInfoService.setAutoPayPlanSubContent('');
                prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5');
                if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                  prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('<p class="fido-tick-icon-secondary">' + $translate('global.label.add') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) + ' ' + $translate('global.label.autoRefillBalanceBridge') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) + '</p>');
                  prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9');
                } else {
                  prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                  prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                }
              }
              $state.go('myAccount.prepaidRefill');
            }
          },
          function (reason) {
            $scope.autoRefillSubscriptionInfoError = true;
          }
        );
      };

    }]);


  angular.module('eclipseApp.myAccount').filter('ctnBasicFormatter', function () {
    return function (value) {
      var i = value.length;
      var j = 4;
      var ctn = '-' + value.substring(i - j, i);
      for (i, j; i - j > 0; j = j + 3) {
        var dd = value.substring(i - j - 3, i - j);
        ctn = ' ' + dd + ctn;
      }
      return ctn;

    };

  });
})();
